import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledText } from '../../Typography/Text/Text.styles.mjs';
import styled from 'styled-components';

const StyledIconButton = styled(IconButtonComponent) `
  span {
    display: flex;
  }

  svg {
    fill: ${props => props.color};
  }
`;
const StyledVolumeSliderContainer = styled(FlexContainer) `
  padding-left: 0.5rem;
`;
const StyledVolumeSliderOuter = styled.div `
  overflow: hidden;
  opacity: 0;
  max-width: 0;
  transition: all ${props => props.theme.animation.duration.quick2}
    ${props => props.theme.animation.easing.productive.standard} 500ms;
`;
const StyledControlContainer = styled.div `
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
  padding-top: 36px;
`;
const StyledControlBarContainer = styled(FlexContainer) `
  background: ${props => props.theme.gradients.videoControlBarOverlay};
  padding: 0 1rem;
  top: ${props => (props.isVisible ? 0 : '100%')};
  left: ${props => (props.isVisible ? 0 : '-100vw')};
  opacity: ${props => (props.isVisible ? 1 : 0)};
  cursor: pointer;
  outline: none;
  transition: all ${props => props.theme.animation.duration.quick2}
    ${props => props.theme.animation.easing.productive.standard} 0ms;

  @media (pointer: fine) {
    &:hover {
      top: 0;
      left: 0;
      opacity: 1;
    }
  }

  ${StyledText} {
    padding: 0;
    margin: 0;
  }
`;
const StyledControlsContainer = styled(FlexContainer) `
  padding: 0 0.5rem 0.625rem;

  svg {
    @media (pointer: fine) {
      &:hover {
        filter: brightness(0) invert(100%);
      }
    }
  }
`;
const StyledVolumeControlContainer = styled(FlexContainer) `
  @media (pointer: fine) {
    &:hover {
      ${StyledVolumeSliderOuter} {
        max-width: 52px;
        overflow: visible;
        opacity: 1;
        transition-delay: 0s;
      }
    }
  }
`;

export { StyledControlBarContainer, StyledControlContainer, StyledControlsContainer, StyledIconButton, StyledVolumeControlContainer, StyledVolumeSliderContainer, StyledVolumeSliderOuter };
//# sourceMappingURL=ControlBar.styles.mjs.map
